import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../components/Logo';

export default function AuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <Logo className="h-12 w-auto text-text-main" />
          <p className="mt-4 text-sm text-text-faint">{t('appTagline')}</p>
        </div>
        <div className="rounded-2xl border border-border-subtle bg-white p-8 shadow-sm">
          {children}
        </div>
      </div>
    </div>
  );
}
